export enum OwnerDocumentDescriptionEnum {
  DOWOD = 'owner.document.id',
  PASZPORT = 'owner.document.passport',
  PRAWO_JAZDY = 'owner.document.drivingLicence',
}
